import React from "react";
import Dropdown from "react-bootstrap/Dropdown";

import { Icon } from "./elements/Icon";
import { DropdownMenu } from "./DropdownMenu";

export function DotsMenu({ dots, dropdown }) {
  return (
    <Dropdown bsPrefix="mc-dropdown">
      <Dropdown.Toggle bsPrefix="mc-dropdown-toggle">
        <Icon type={dots} />
      </Dropdown.Toggle>
      <DropdownMenu className="mc-dropdown-paper" dropdown={dropdown} />
    </Dropdown>
  );
}
